import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectLeadDetail, useGetLeadDetailOnMount } from '@user/store/lead'
import {
  selectOpportunityDetail,
  useGetOpportunityDetailOnMount,
} from '@user/store/opportunity'

export type FormPacketItemDetails = {
  id: number
  externalLocationCode: string
  externalLocationId: string
}

export function useLeadOrOppDetails(entityType: ENTITY_TYPES) {
  const isLeadDetails = entityType === ENTITY_TYPES.Lead
  const leadDetails = useSelector(selectLeadDetail)
  const opportunityDetails = useSelector(selectOpportunityDetail)

  return isLeadDetails ? leadDetails : opportunityDetails
}

export function useGetEntityDetailsOnMount(
  entityId: number,
  entityType: ENTITY_TYPES,
) {
  const hook =
    entityType === ENTITY_TYPES.Lead
      ? useGetLeadDetailOnMount
      : useGetOpportunityDetailOnMount

  return hook(Number(entityId))
}
